import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";

export class InvoiceItemPrintModel {
  public RowNumber: number;
  public ItemTitle: string;
  public Quantity: number;
  public UnitPrice: number;
  public Price: number;
  public TotalPrice: number;
  public UnitAdditive: number;
  public UnitPriceDiscount: number;
  public UnitDiscount: number;
  public UnitToll: number;
  public UnitService: number;
  public UnitTax: number;
  public NewQuantity: number;
  public Title_En: string;
  public Free: boolean;
  public ItemId: number;
  public CategoryId?: number;
  public ParentCategoryId?: number;
  public Description: string;
  public Deleted: boolean;
  public HasDecimal?: boolean;
  public PrintDisplayOrder?: number;
  public Index?: number;
  public State?: RowState;
  public Debit: number;
  public PackingPrice: number;
  constructor() {
    this.ItemTitle = "";
    this.Free = false;
    this.Deleted = false;
    this.HasDecimal = false;
    this.Title_En = "";
    this.Description = "";
    this.Quantity = 0;
    this.PrintDisplayOrder = 0;
    this.Index = 0;
    this.State = 0;
    this.UnitPrice = 0;
    this.Price = 0;
    this.TotalPrice = 0;
    this.UnitAdditive = 0;
    this.UnitPriceDiscount = 0;
    this.UnitDiscount = 0;
    this.UnitToll = 0;
    this.UnitService = 0;
    this.UnitTax = 0;
    this.NewQuantity = 0;
    this.ItemId = 0;
    this.CategoryId = 0;
    this.ParentCategoryId = 0;
    this.Debit = null;
    this.PackingPrice = null;
  }
}
export class InvoicePrintModel {
  public SaleMethodNatureCode: number;
  public IsBarCodeInvoice?: boolean;
  public IsMultiPrint: boolean;
  public IsReceiptPrint: boolean;
  public Title: string;
  public RestaurantTitle: string;
  public RestaurantEconomicalNumber: string;
  public RestaurantPostalCode: string;
  public MealTimeTitle: string;
  public DeliveryType: string;
  public CreateDate: Date;
  public RestaurantAddress: string;
  public RestaurantPhoneNumber: string;
  public MultiPhoneNumber: string;
  public CurrencyCode: number;
  public ClearType: string;
  public CurrencyTitle: string;
  public CustomerDisplayName: string;
  public CustomerTitle: string;
  public CustomerNumber: string;
  public Items: InvoiceItemPrintModel[];
  public CustomerPhoneNumber: string;
  public NumberOfGuests: number;
  public ShippingAddress: string;
  public ShippingCost: number;
  public PackingPrice: number;
  public Total: number;
  public TotalNet: number;
  public TotalDiscount: number;
  public TotalService: number;
  public TotalTax: number;
  public TotalToll: number;
  public PayableTotal: number;
  public ShamsiCreatedDate: string;
  public CreatedDateTime: string;
  public NumberingInDate?: number;
  public OldNumberingInDate?: number;
  public WaiterName: string;
  public CreatedUserName: string;
  public CreatedUserPhoneNumber: string;
  public TableTitle: string;
  public OldTableTitle: string;
  public DependentPrintPolicyTitles: string;
  public Corrective: boolean;
  public RePrint: boolean;
  public DriverDisplayName: string;
  public DriverCode?: number;
  public PrintTime: string;
  public PrintTimeCode: number;
  public RandomNumber: number;
  public Description: string;
  public DescCustomer: string;
  public DescKitchen: string;
  public Message: string;
  public DisplayLogoInPrintTemplates: boolean;
  public PolicyTitle: string;
  public IgnoreBlackBackground: boolean;
  public FreeShipping: boolean;
  public DisplayAddressInInvoice: boolean;
  public StatusCode?: number;
  public Debit?: number;
  public Credit?: number;
  public HasDecimal?: boolean;
  public Logo: any[];
  public State: RowState;
  public Branch: Branch;
  public Title_En: string;
  CustomerName: string;
  LocalServiceIp: string;
  public OldSaleMethodBranchId: number;
  public DaysOfWeek: string;
  public PrintDescription: string;
  OtherPrintTemplateId?: number;
  public BranchNationalCode: string;
  public CustomerRegistrationNumber: string;
  public CustomerEconomicCode?: number;
  public CustomerNationalCode: string;
  public CustomerNationalId: string;
  public CustomerPostalCode: string;
  public ServingFoodDate: string;
  public ServingFoodTime: string;
  public NumberOfPeople?: number;
  public ServicesAmount?: number;
  public HasTotalDebit: boolean;
  public HasDirectlyTaxpayer: boolean;
  public CustomerTotalDebit?: number;
  public DepositAmount?: number;
  public RemainingAmount?: number;
  public CooksServicesAmount: string;
  public CourierServicesAmount: string;
  public RemainingAmountToPersian: string;
  public IsPickUp: boolean;
  public TotalCalories?: number;
  public ItemCountDisplay: boolean;
  public ItemCount: string;
  PayableAmountToPersian: string;
  constructor() {
    this.State = 0;
    this.OldSaleMethodBranchId = 0;
    this.CustomerTotalDebit = null;
    this.SaleMethodNatureCode = 0;
    this.Title = "";
    this.TotalCalories = null;
    this.PrintDescription = "";
    this.RestaurantTitle = "";
    this.RestaurantEconomicalNumber = "";
    this.IsMultiPrint = false;
    this.IsReceiptPrint = false;
    this.RestaurantPostalCode = "";
    this.MealTimeTitle = "";
    this.RestaurantAddress = "";
    this.RestaurantPhoneNumber = "";
    this.CurrencyCode = 0;
    this.CurrencyTitle = "";
    this.CustomerDisplayName = "";
    this.CustomerTitle = "";
    this.CustomerNumber = "";
    this.CustomerPhoneNumber = "";
    this.NumberOfGuests = 0;
    this.ShippingAddress = "";
    this.Title_En = "";
    this.ShippingCost = 0;
    this.PackingPrice = 0;
    this.Total = 0;
    this.DaysOfWeek = "";
    this.TotalNet = 0;
    this.TotalDiscount = 0;
    this.TotalService = 0;
    this.TotalTax = 0;
    this.TotalToll = 0;
    this.CreatedUserPhoneNumber = "";
    this.PayableTotal = 0;
    this.ShamsiCreatedDate = "";
    this.CreatedDateTime = "";
    this.NumberingInDate = 0;
    this.OldNumberingInDate = 0;
    this.WaiterName = "";
    this.CreatedUserName = "";
    this.TableTitle = "";
    this.OldTableTitle = "";
    this.DependentPrintPolicyTitles = "";
    this.Corrective = false;
    this.RePrint = false;
    this.DriverDisplayName = "";
    this.PrintTime = null;
    this.Description = "";
    this.DescCustomer = "";
    this.DescKitchen = "";
    this.Message = "";
    this.DisplayLogoInPrintTemplates = false;
    this.PolicyTitle = "";
    this.IgnoreBlackBackground = false;
    this.FreeShipping = false;
    this.DisplayAddressInInvoice = false;
    this.StatusCode = 0;
    this.Debit = 0;
    this.Credit = 0;
    this.HasDecimal = false;
    this.Logo = [];
    this.BranchNationalCode = "";
    this.CustomerRegistrationNumber = "";
    this.CustomerEconomicCode = null;
    this.CustomerNationalCode = "";
    this.CustomerNationalId = "";
    this.CustomerPostalCode = "";
    this.ServingFoodDate = "";
    this.ServingFoodTime = "";
    this.NumberOfPeople = null;
    this.ServicesAmount = null;
    this.DepositAmount = null;
    this.RemainingAmount = null;
  }
}
export class PrintDocumentInvoiceModel {
  public InvoicePrintModel: InvoicePrintModel[];
  public PrinterName: string;
  public TemplateName: string;
  public LocalServiceIp: string;
  constructor(lists: InvoicePrintModel[], printerName: string, templateName: string, localServiceIp: string) {
    this.InvoicePrintModel = lists;
    this.PrinterName = printerName;
    this.LocalServiceIp = localServiceIp;
    this.TemplateName = templateName;
  }
}
